var _rect, _path, _rect2, _path2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path3, _rect10, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 63.2926,
    height: 41.2665,
    rx: 2,
    transform: "matrix(0.98844 -0.151616 0.147468 0.989067 2.91565 23.6299)",
    fill: "#F7CC6D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4462 19.9064C48.1493 18.193 49.2788 16.5183 50.9978 16.2546L63.4997 14.3369C64.5915 14.1695 65.6086 14.9194 65.7715 16.0118L71.2671 52.8709C71.43 53.9634 70.677 54.9848 69.5852 55.1523L10.978 64.142C9.88622 64.3095 8.8691 63.5596 8.70621 62.4671L7.6179 55.1678C7.37357 53.5291 8.51486 51.9971 10.15 51.7292C44.0082 46.1805 51.6449 38.3683 48.4462 19.9064Z",
    fill: "#F4BC5F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9141,
    y: 24.0312,
    width: 62,
    height: 40,
    rx: 2,
    fill: "#63AFFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5677 27.2554C57.5294 25.5158 58.8932 24.0312 60.6332 24.0312H72.9141C74.0186 24.0312 74.9141 24.9267 74.9141 26.0312V62.0312C74.9141 63.1358 74.0186 64.0312 72.9141 64.0312H14.9141C13.8095 64.0312 12.9141 63.1358 12.9141 62.0312V55.0312C12.9141 53.3744 14.2675 52.0332 15.9243 52.0161C49.4184 51.6695 57.9658 45.3264 57.5677 27.2554Z",
    fill: "#529FFB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.9141,
    y: 56.0312,
    width: 10,
    height: 3.4,
    rx: 1.7,
    fill: "#82C8FB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.9141,
    y: 40.0312,
    width: 20,
    height: 5,
    rx: 2.5,
    fill: "#82C8FB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9141,
    y: 56.0312,
    width: 10,
    height: 3.4,
    rx: 1.7,
    fill: "#82C8FB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9141,
    y: 56.0312,
    width: 10,
    height: 3.4,
    rx: 1.7,
    fill: "#82C8FB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 57.9141,
    y: 56.0312,
    width: 10,
    height: 3.4,
    rx: 1.7,
    fill: "#82C8FB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9141,
    y: 30.0312,
    width: 62,
    height: 6,
    fill: "#626681"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 53.8401,
    y: 46.8833,
    width: 7.07407,
    height: 7.07407,
    transform: "rotate(-43.3224 53.8401 46.8833)",
    fill: "#F7CC6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4132 44.6049L63.84 47.1781L58.6936 52.0317L56.2668 49.4584C56.3601 48.8212 57.2051 48.5488 57.8419 48.6448C59.2405 48.8558 60.4955 47.5152 60.1266 45.8183C60.0301 44.3791 61.4132 44.6049 61.4132 44.6049Z",
    fill: "#F4BC5F"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 60.9139,
    y: 46.8838,
    width: 7.07407,
    height: 7.07407,
    transform: "rotate(-43.3224 60.9139 46.8838)",
    fill: "#FC4A32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4871 44.6054L70.9138 47.1786L65.7674 52.0321L63.3406 49.4589C63.434 48.8217 64.2789 48.5493 64.9158 48.6453C66.3143 48.8563 67.5693 47.5157 67.2005 45.8188C67.1039 44.3796 68.4871 44.6054 68.4871 44.6054Z",
    fill: "#E23E2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardPayment);
export default __webpack_public_path__ + "static/media/cardPayment.ea955bbe36c8d69deda76f4b5f5c78c1.svg";
export { ForwardRef as ReactComponent };